import { useState } from 'react';
import { Search, List } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import { PicklistConfig } from '@/config/picklists';

interface PicklistSelectorProps {
  picklists: PicklistConfig[];
  selectedId: string | null;
  onSelect: (picklist: PicklistConfig) => void;
}

export default function PicklistSelector({
  picklists,
  selectedId,
  onSelect,
}: PicklistSelectorProps) {
  const [search, setSearch] = useState('');

  const filteredPicklists = picklists.filter((p) =>
    p.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="flex flex-col h-full">
      <div className="p-3 border-b border-border">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input
            placeholder="Search picklists..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="pl-9"
          />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
        {filteredPicklists.length === 0 ? (
          <div className="p-4 text-center text-muted-foreground text-sm">
            No picklists found
          </div>
        ) : (
          <div className="p-2">
            {filteredPicklists.map((picklist) => (
              <button
                key={picklist.id}
                onClick={() => onSelect(picklist)}
                className={cn(
                  'w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-left transition-colors',
                  selectedId === picklist.id
                    ? 'bg-primary text-primary-foreground'
                    : 'hover:bg-secondary/50 text-foreground'
                )}
              >
                <List className="w-4 h-4 flex-shrink-0" />
                <div className="min-w-0">
                  <p className="font-medium truncate">{picklist.name}</p>
                  {picklist.description && (
                    <p
                      className={cn(
                        'text-xs truncate',
                        selectedId === picklist.id
                          ? 'text-primary-foreground/70'
                          : 'text-muted-foreground'
                      )}
                    >
                      {picklist.description}
                    </p>
                  )}
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
